import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/home'),
  },
  {
    path: '/homemap',
    name: 'homemap',
    component: () => import('@/views/homemap'),
  }
]

const router = new VueRouter({
  routes
})

export default router
